export default __webpack_public_path__ + "static/media/Pop_Baptiste.303f0aea.png";